// extracted by mini-css-extract-plugin
export default {"title":"index-module_title_0fMkS","full":"index-module_full_bsnXc","textPart":"index-module_textPart_EmHhL","addonAfter":"index-module_addonAfter_8F-qr"};